import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  getCategories,
  getCitiesByState,
  getLocalityByState,
  getSingleOffer,
  getStates,
  getUnits,
  getmarketsByState,
} from "../../../api";
import AppBar from "../../../components/appBar";
import { api_url } from "../../../constant";
import background from "../../../images/background.png";
import Client from "../../../utils/client";
import Confirmation from "./confirmation";
import ReactGA from "react-ga4";


const videoExtenstions = ["mp4", "avi", "mov", "wmv"];
const imageExtenstions = ["jpg", "jpeg", "png", "gif"];

function AddAuction({ isEdit = false }) {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Add Auction",
  });
  const [modal, setModal] = useState(false);
  const [media, setMedia] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
  } = useForm();

  const [first, setFirst] = useState();
  const navigate = useNavigate();
  let { id } = useParams();

  const { data: subCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: cities, refetch: citiesRefetch } = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCitiesByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: markets, refetch: marketRefetch } = useQuery({
    queryKey: ["markets"],
    queryFn: () => getmarketsByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: locality, refetch: localityRefetch } = useQuery({
    queryKey: ["locality"],
    queryFn: () => getLocalityByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: units } = useQuery({
    queryKey: ["units"],
    queryFn: () => getUnits(),
  });

  const {} = useQuery({
    queryKey: ["offer"],
    queryFn: () => getSingleOffer(id),
    enabled: isEdit,
    onSuccess: (data) => {
      reset({
        state: { label: data._state.name, value: data._state.id },
        city: { label: data._city.name, value: data._city.id },
        locality: data._locality
          ? { label: data._locality.name, value: data._locality.id }
          : null,
        market: data._market
          ? { label: data._market.name, value: data._market.id }
          : null,
        offer: data.offer,
        category_id: 1,
        quantity: data.quantity.toString(),
        subCategory_id: {
          label: data.subCategory.name,
          value: data.subCategory.id,
        },
        unit: { label: data._unit.name, value: data._unit.id },
      });
    },
  });

  const onSubmit = (data) => post(data);

  const upload = async (e) => {
    var formData = new FormData();
    formData.append("image", e);
    const url = "https://api.mahsool.sd/image/upload";
    // const url = "http://127.0.0.1:3060/image/upload";
    const response = await fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token").split('"')[1],
      },
    }).then((res) => res.json());
    setMedia([...media, response.url]);
    // se(reponse)
    // form.setValue("image_url", reponse)
  };

  const post = async (data) => {
    const imagesList = [];
    const viedosList = [];

    media.forEach((link) => {
      const extension = link.split(".").pop().toLowerCase();
      if (imageExtenstions.includes(extension)) {
        imagesList.push(link);
      } else if (videoExtenstions.includes(extension)) {
        viedosList.push(link);
      }
    });


    const _data = JSON.stringify({
      category_id: 1,
      images: imagesList,
      video: viedosList,
      quantity: data.quantity,
      description: data.offer,
      sub_category: data.subCategory_id.value,
      locality: data.locality?.value || null,
      city: data.city.value,
      market: data.market?.value || null,
      state: data.state.value,
      unit: data.unit.value,
      opening_price: data.price,
    });

    if (isEdit) {
      await Client.post(
        process.env.REACT_APP_API_URL + `/offers/edit/${id}`,
        _data,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => navigate("/"))
        .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
    } else {
      await Client.post(process.env.REACT_APP_API_URL + "/auction", _data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((res) => setModal(true))
        .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
    }
  };

  const sold = async () => {
    await Client.post(
      api_url + `/offers/edit/${id}`,
      JSON.stringify({ status: "sold" }),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((res) => navigate("/"))
      .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
  };

  return (
    <div className="items-center overflow-x-hidden justify-center w-screen h-screen">
      <AppBar key="5" />
      {modal ? <Confirmation /> : ""}
      <div className="h-10" />
      <div className="flex flex-row justify-between px-40 font-bold text-primary text-[18px]">
        <div
          className="flex justify-center items-center"
          onClick={() => navigate("/home")}
        >
          <svg
            className="w-7 text-primary"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5L8.25 12l7.5-7.5"
            />
          </svg>
          <p>العودة إلى القائمة</p>
        </div>
        <div className="text-black">فتح مزاد</div>
      </div>
      <div className="h-10"></div>
      <div className="flex flex-col">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col items-center justify-center"
        >
          <div className="flex flex-col w-2/6">
            <ReactSelect
              className="border-primary border-[1px] rounded-md"
              options={subCategories.map((e) => {
                return { label: e.name, value: e.id };
              })}
              value={getValues().subCategory_id}
              onChange={(value) =>
                reset({ ...getValues(), subCategory_id: value })
              }
              hideSelectedOptions={false}
              closeMenuOnSelect={true}
              isRtl
              placeholder={
                <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
                  المحصول
                </span>
              }
            />
          </div>
          <div className="h-5" />

          <div className="flex flex-col-reverse lg:flex-row lg:gap-5 w-full justify-center items-center">
            <div className="flex flex-col w-2/6 lg:w-1/6">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={cities.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().city}
                onChange={(value) => reset({ ...getValues(), city: value })}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={
                  <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
                    المدينة
                  </span>
                }
                isDisabled={cities.length === 0}
              />
            </div>

            <div className="h-5" />

            <div className="flex flex-col w-2/6 lg:w-1/6">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={states.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().state}
                onChange={(value) => {
                  setValue("state", value);
                  citiesRefetch();
                  marketRefetch();
                  localityRefetch();
                }}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={
                  <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
                    الولاية
                  </span>
                }
              />
            </div>
          </div>
          <div className="h-5" />

          <div className="flex flex-col lg:flex-row lg:gap-5 justify-center items-center w-96">
            <div className="flex flex-col w-full">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={markets.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().market}
                onChange={(value) => reset({ ...getValues(), market: value })}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder="السوق"
                isDisabled={markets.length === 0}
              />
            </div>

            <div className="h-5" />

            <div className="flex flex-col w-full">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={locality.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().locality}
                onChange={(value) => {
                  reset({ ...getValues(), locality: value });
                }}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                isDisabled={locality.length === 0}
                placeholder="المحلية"
              />
            </div>
          </div>

          <div className="h-5" />

          <div className="relative ">
            <span className="absolute  -right-3 text-xl text-red-500">*</span>
            <input
              {...register("offer", { required: true })}
              className="border-[1px] h-32 p-3 mb-5 rounded-md w-96 border-primary placeholder:font-bold placeholder:text-base  "
              multiple
              placeholder="الوصف"
              dir="rtl"
            />
          </div>

          {/* <input {...register("location")} className="border-2 h-12 p-3 mb-5 rounded-md w-96" placeholder='الموقع' /> */}
          <div className="flex flex-col-reverse lg:flex-row lg:gap-5 w-96 justify-center items-center">
            <div className="flex flex-col w-full">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={units?.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().unit}
                onChange={(value) => reset({ ...getValues(), unit: value })}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={
                  <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
                    الوحدة
                  </span>
                }
                isDisabled={units?.length === 0}
              />
            </div>
            <div className="relative">
              <span className="absolute  -right-3 text-xl text-red-500">*</span>
              <input
                type="number"
                min="1"
                {...register("quantity", {
                  valueAsNumber: true,
                  validate: (value) => value > 0,
                })}
                className="border-[1px] h-10 p-3 rounded-md w-52 border-primary placeholder:font-bold placeholder:text-base"
                placeholder="الكمية"
                dir="rtl"
              />
            </div>
          </div>
          <div className="h-5" />

          <div className="relative">
            <span className="absolute  -right-3 text-xl text-red-500">*</span>
            <input
              type="number"
              {...register("price", { required: true })}
              className="border-[1px] h-12 p-3 mb-5 rounded-md w-96 border-primary placeholder:font-bold placeholder:text-base"
              placeholder="سعر فتح المزاد"
              dir="rtl"
            />
          </div>

          {/* <button
                        hidden={!isEdit}
                        type="button"
                        {...register("status")}
                        className="border-2 h-12 p-3 mb-5 rounded-md w-60 bg-amber-600 text-white font-bold text-lg"
                        value="تم البيع؟"
                        onClick={() => sold()}
                    >
                        تم البيع؟
                    </button> */}
          <div className="w-96 h-[20vh] border-primary border-[1px] bg-gray-50 rounded-md flex justify-center items-center text-gray-500">
            <input
              type="file"
              id="file"
              className="hidden"
              onChange={(e) => upload(e.target.files[0])}
            />

            <label
              htmlFor="file"
              className="font-bold before:content-['*'] before:mr-1 before:text-red-500 "
            >
              إرفق صورة أو فديو
            </label>
          </div>
          <div className="h-5" />
          <div className="flex flex-row gap-3">
            {media.length > 0 &&
              media?.map((e, index) =>
                videoExtenstions.includes(e.split(".").pop().toLowerCase()) ? (
                  <video controls className="w-16" key={index}>
                    <source src={e} type="video/mp4" />
                  </video>
                ) : (
                  <img src={e} className="w-16" key={index} />
                )
              )}
          </div>
          <div className="h-5" />

          <input
            type="submit"
            className="h-12 bg-primary text-white rounded-md w-60"
            value={isEdit ? "تعديل" : "فتح المزاد"}
          />
        </form>
      </div>
      <div className="fixed left-0 bottom-1 z-0">
        <img src={background} alt="" className="lg:w-[20vw] w-[50vw]" />
      </div>
    </div>
  );
}

export default AddAuction;
